import React from 'react'
import { useOutletContext } from 'react-router-dom'

import WizardContainer from './shared/WizardContainer'
import LeadImport from '../settings/LeadImportSetup'

const LeadImportSetup = () => {
  const { navigateToNext, wizardState, updateWizardState } = useOutletContext()

  return (
    <WizardContainer>
      <LeadImport
        onDone={navigateToNext}
        state={wizardState}
        updateState={updateWizardState}
      />
    </WizardContainer>
  )
}

export default LeadImportSetup
